import GetDateFormatedService from 'modules/inbound/shared/domain/GetDateFormatedService';
import {
  UnloadingPoint,
  UnloadingPointInfo,
  UnloadingPointTruck
} from '../../domain/unloadingPoint';
import {
  UnloadingPointDTO,
  UnloadingPointInfoDTO,
  UnloadingPointInfoListDTO,
  UnloadingPointTruckDTO
} from '../dto/unloadingPointDTO';

export class UnloadingPointMapper {
  static unloadingPointTruckToDomain(
    dto: UnloadingPointTruckDTO
  ): UnloadingPointTruck {
    return new UnloadingPointTruck(
      dto.transport_id,
      dto.vehicle_plate,
      dto.carrier,
      dto.state,
      dto.last_update,
      dto.execution_order,
      dto.current_action,
      dto.urgent
    );
  }

  static unloadingPointToDomain(dto: UnloadingPointDTO): UnloadingPoint {
    return new UnloadingPoint(
      dto.last_position,
      dto.trucks_count,
      dto.trucks.map((item) => this.unloadingPointTruckToDomain(item))
    );
  }

  static unloadingPointInfoToDomain(
    dto: UnloadingPointInfoDTO
  ): UnloadingPointInfo {
    return new UnloadingPointInfo(
      dto.timestamp,
      dto.workshop,
      dto.unloading_points.map((item) => this.unloadingPointToDomain(item)),
      dto.total_trucks
    );
  }

  static unloadingPointInfoListToDomain(dto: {
    data: UnloadingPointInfoDTO;
  }): UnloadingPointInfo {
    return this.unloadingPointInfoToDomain(dto.data);
  }

  static unloadingPointInfoListDtoToDomain(
    dto: UnloadingPointInfoListDTO
  ): UnloadingPointInfo {
    const formatedTimestamp = dto.data.timestamp
      ? GetDateFormatedService.dateFromISO8601(dto.data.timestamp)
      : '';
    dto.data.timestamp = formatedTimestamp
      ? `${GetDateFormatedService.getDateFormated(
          formatedTimestamp,
          'de-DE'
        )} | ${GetDateFormatedService.getTimeFormated(formatedTimestamp)}`
      : '';
    return this.unloadingPointInfoToDomain(dto.data);
  }
}
